import { render } from "./DotnetSubComponent.vue?vue&type=template&id=213b44d6"
import script from "./DotnetSubComponent.vue?vue&type=script&lang=js"
export * from "./DotnetSubComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__